const list = {
    or: 'hoặc',
    and: 'và',
    separator: ',',
};
export default Object.freeze(list);
